import SampleRequests from './SampleRequests';

export default SampleRequests;
